import EfIcon from '@elem/ui/ef-icon';
import EfXCore from '@elem/ui/ef-x-core';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';

export default function TheComp() {
    const { t } = useLang('rapid.XCoreA');
    const { locale } = useRouter();

    return (
        <div className={css.comp}>
            <EfXCore
                title={<EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722326378837/X-core.png" />}
                desc={t('desc')}
                btnLink={['us', 'ca'].includes(locale) ? `https://www.ecoflow.com/${locale}/x-core-3` : ''}
                btnText={['us', 'ca'].includes(locale) ? t('btn') : ''}
            />
            <EfSpec />
        </div>
    );
}
